import axios from "axios";
import { ENROLLMENT_API_URL } from "../config/app-config";
import {
  bearerTokenRequestInterceptor,
  createRequestFunction
} from "../create-api-client";
const client = axios.create({
  baseURL: ENROLLMENT_API_URL
});
client.interceptors.request.use(bearerTokenRequestInterceptor);
const enrollmentApiRequest = createRequestFunction(client);
export {
  client,
  enrollmentApiRequest
};
